import { FC } from 'react';
import { ReactComponent as EmptyIcon } from 'assets/icons/Empty.svg';
import { ReactComponent as EmptySearchIcon } from 'assets/icons/EmptySearch.svg';
import { ReactComponent as EmptyCartIcon } from 'assets/icons/EmptyCart.svg';
import { ReactComponent as EmptyItemIcon } from 'assets/icons/EmptyItem.svg';
import { ReactComponent as PageNotFoundIcon } from 'assets/icons/PageNotFound.svg';
import { ReactComponent as EmptyCouponIcon } from 'assets/icons/EmptyCoupon.svg';
import { Card, CardContent, CardProps, Typography } from '@mui/material';

interface EmptyStateProps extends CardProps {
  title?: string;
  type?: 'default' | 'search' | 'cart' | 'item' | 'coupon' | '404';
  contentClassName?: string;
}
const EmptyState: FC<EmptyStateProps> = ({
  title,
  type = 'default',
  children,
  className,
  contentClassName,
  ...props
}) => {
  const EmptyStateIcon = () => {
    switch (type) {
      case 'cart':
        return <EmptyCartIcon />;

      case 'search':
        return <EmptySearchIcon />;

      case 'item':
        return <EmptyItemIcon />;

      case 'coupon':
        return <EmptyCouponIcon />;

      case '404':
        return <PageNotFoundIcon />;

      default:
        return <EmptyIcon />;
    }
  };
  return (
    <Card
      elevation={0}
      {...props}
      className={className ? `!bg-gray-100 ${className}` : '!bg-gray-100'}
    >
      <CardContent
        className={`mx-auto flex min-h-[70vh] w-full max-w-[375px] flex-col items-center justify-center space-y-6 ${contentClassName}`}
      >
        <EmptyStateIcon />
        <Typography
          variant='body1'
          fontWeight={700}
          color='text.secondary'
          textAlign='center'
          whiteSpace='pre-wrap'
        >
          {title}
        </Typography>
        <>{children}</>
      </CardContent>
    </Card>
  );
};

export default EmptyState;
